import FileUploader from "./MultiFileUploader";
import FileAnalyser, { FileAnalysisResult } from "./FileAnalyser";
import { useState } from "react";

interface PlannerSetupProps {
  files: File[];
  setFiles: (files: File[]) => void;

  selectedLanguage: string;
  onLanguageChange: (language: string) => void;

  selectedUseCases: string[];
  onUseCaseToggle: (usecase: string) => void;

  onAnalysisComplete: (results: FileAnalysisResult[]) => void;

  isPostGenerating: boolean;
  postGenerationStep: string;
  onAnalysisDuration?: (durationMs: number) => void;
}

export default function PlannerSetup({
  files,
  setFiles,
  selectedLanguage,
  onLanguageChange,
  selectedUseCases,
  onUseCaseToggle,
  onAnalysisComplete,
  isPostGenerating,
  postGenerationStep,
  onAnalysisDuration
}: PlannerSetupProps) {


  return (
    <div className="planner-setup">
      <FileUploader setFiles={setFiles} />

      <div className="planner-setup__section">
        <label className="field-label">Sprache</label>

        <div className="segmented-control">
          <button
            type="button"
            className={selectedLanguage === "german" ? "active" : ""}
            onClick={() => onLanguageChange("german")}
          >
            Deutsch
          </button>

          <button
            type="button"
            className={selectedLanguage === "english" ? "active" : ""}
            onClick={() => onLanguageChange("english")}
          >
            English
          </button>
        </div>
      </div>

      <div className="planner-setup__section">
        <label className="field-label">
          Kanäle
        </label>

        <div className="planner-usecases">
          <UseCaseButton
            label="LinkedIn · AG Serious Games"
            selected={selectedUseCases.includes("LinkedInAG")}
            onClick={() => onUseCaseToggle("LinkedInAG")}
          />

          <UseCaseButton
            label="LinkedIn · GameDays"
            selected={selectedUseCases.includes("LinkedInGameDays")}
            onClick={() => onUseCaseToggle("LinkedInGameDays")}
          />

          <UseCaseButton
            label="LinkedIn · Personal"
            selected={selectedUseCases.includes("LinkedInPersonal")}
            onClick={() => onUseCaseToggle("LinkedInPersonal")}
          />

          <UseCaseButton
            label="News · AG Serious Games"
            selected={selectedUseCases.includes("FirstSpiritAG")}
            onClick={() => onUseCaseToggle("FirstSpiritAG")}
          />

          <UseCaseButton
            label="News · TU Darmstadt"
            selected={selectedUseCases.includes("FirstSpiritTU")}
            onClick={() => onUseCaseToggle("FirstSpiritTU")}
          />
        </div>
      </div>

      <FileAnalyser
        files={files}
        onAnalysisComplete={onAnalysisComplete}
        language={selectedLanguage}
        usecases={selectedUseCases}
        externalBusy={isPostGenerating}
        externalBusyLabel={postGenerationStep}
        onAnalysisDuration={onAnalysisDuration}
      />
    </div>
  );
}

interface UseCaseButtonProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

function UseCaseButton({
  label,
  selected,
  onClick,
}: UseCaseButtonProps) {
  return (
    <button
      type="button"
      className={
        selected
          ? "planner-usecase planner-usecase--selected"
          : "planner-usecase"
      }
      onClick={onClick}
    >
      {label}
    </button>
  );
}